import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import { handleApiError } from "../../Helpers/handleApiError ";
import Swal from "sweetalert2";

const getToken = () => localStorage.getItem("u_token");

// Fetch Cover Images
export const fetchCoverImages = createAsyncThunk(
    "images/fetchCoverImages",
    async (_, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}admin/cover-images`, {
                headers: { Authorization: `Bearer ${token}` },
            });


            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch cover images." });
        }
    }
);

// Fetch Summary Images
export const fetchSummaryImages = createAsyncThunk(
    "images/fetchSummaryImages",
    async (_, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}admin/summary-images`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch summary images." });
        }
    }
);

// Fetch Theme Images
export const fetchThemeImages = createAsyncThunk(
    "images/fetchThemeImages",
    async (_, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}admin/theme-images`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch theme images." });
        }
    }
);

// Fetch Last Images
export const fetchLastImages = createAsyncThunk(
    "images/fetchLastImages",
    async (_, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}admin/last-images`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch last images." });
        }
    }
);
export const fetchTechImages = createAsyncThunk(
    "images/fetchTechImages",
    async (_, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}admin/technology`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch last images." });
        }
    }
);
export const fetchCommunicationImages = createAsyncThunk(
    "images/fetchCommunicationImages",
    async (_, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}admin/communication`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch last images." });
        }
    }
);

// Fetch ALL PDF images in a single API call (consolidated)
export const fetchAllPdfImages = createAsyncThunk(
    "images/fetchAllPdfImages",
    async (_, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}user/all-pdf-images`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch PDF images." });
        }
    }
);

// Add Cover Image
export const addCoverImage = createAsyncThunk(
    "images/addCoverImage",
    async ({ image, name }, { rejectWithValue }) => {
        console.log(image)
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        const formData = new FormData();
        formData.append("image", image);
        formData.append("name", name);

        try {
            const response = await axios.post(`${Apiurl}admin/cover-images/add`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            Swal.fire({
                icon: "success",
                title: "Cover Page",
                text: "Added  successfully",
                timer: 3000,
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Failed to add. Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to add cover image." });
        }
    }
);

// Add Summary Image
export const addSummaryImage = createAsyncThunk(
    "images/addSummaryImage",
    async ({ image, name }, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        const formData = new FormData();
        formData.append("image", image);
        formData.append("name", name);

        try {
            const response = await axios.post(`${Apiurl}admin/summary-images/add`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            Swal.fire({
                icon: "success",
                title: "Summary Image",
                text: "Added  successfully",
                timer: 3000,
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Failed to add. Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to add summary image." });
        }
    }
);

// Add Theme Image
export const addThemeImage = createAsyncThunk(
    "images/addThemeImage",
    async ({ image, name }, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        const formData = new FormData();
        formData.append("image", image);
        formData.append("name", name);

        try {
            const response = await axios.post(`${Apiurl}admin/theme-images/add`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            Swal.fire({
                icon: "success",
                title: "Theme Image",
                text: "Added  successfully",
                timer: 3000,
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Failed to add. Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to add theme image." });
        }
    }
);

// Add Last Image
export const addLastImage = createAsyncThunk(
    "images/addLastImage",
    async ({ image, name }, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        const formData = new FormData();
        formData.append("image", image);
        formData.append("name", name);

        try {
            const response = await axios.post(`${Apiurl}admin/last-images/add`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            Swal.fire({
                icon: "success",
                title: "Last Page",
                text: "Added  successfully",
                timer: 3000,
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Failed to add. Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to add last image." });
        }
    }
);
export const addCommunicationImage = createAsyncThunk(
    "images/addCommunicationImage",
    async ({ image, name }, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        const formData = new FormData();
        formData.append("image", image);
        formData.append("name", name);

        try {
            const response = await axios.post(`${Apiurl}admin/communication/add`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            Swal.fire({
                icon: "success",
                title: "Push Communication",
                text: "Added  successfully",
                timer: 3000,
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Failed to add. Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to add last image." });
        }
    }
);
export const addTechImage = createAsyncThunk(
    "images/techImage",
    async ({ image, name }, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        const formData = new FormData();
        formData.append("image", image);
        formData.append("name", name);

        try {
            const response = await axios.post(`${Apiurl}admin/technology/add`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            Swal.fire({
                icon: "success",
                title: "Technology / Mot's",
                text: "Added  successfully",
                timer: 3000,
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Failed to add. Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to add last image." });
        }
    }
);

// Delete Image
export const deleteImageThunk = createAsyncThunk(
    "images/deleteImage",
    async ({ id, type }, { rejectWithValue }) => {
        const token = getToken();
        if (!token) {
            return rejectWithValue({ message: "Authentication failed, no token found." });
        }

        const endpointMap = {
            cover: "admin/cover-images/delete",
            summary: "admin/summary-images/delete",
            theme: "admin/theme-images/delete",
            last: "admin/last-images/delete",
            tech: "admin/technology/delete",
            communication: "admin/communication/delete",
        };

        const endpoint = endpointMap[type];
        if (!endpoint) {
            return rejectWithValue({ message: "Invalid image type provided." });
        }

        const url = `${Apiurl}${endpoint}/${id}`;
        try {
            await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` },
            });
            Swal.fire({
                icon: "success",
                title: "",
                text: "Deleted  successfully",
                timer: 3000,
            });
            return { id, type };
        } catch (error) {
            handleApiError(error, "Failed to delete. Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to delete image." });
        }
    }
);

export const fetchPdfSettings = createAsyncThunk(
    "fetchPdfSettings",
    async (_, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}pdf-setting`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch." });
        }
    }
);

export const updatePdfSettings = createAsyncThunk(
    "updatePdfSettings",
    async (datas, { rejectWithValue, dispatch }) => {
        const token = getToken();

        if (!token) {
            return rejectWithValue({
                message: "No token found, authorization failed.",
            });
        }

        try {
            const response = await axios.post(
                `${Apiurl}pdf-setting/update/${datas.id}`,
                datas,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            Swal.fire({
                icon: "success",
                title: "Settings!",
                text: "Updated Successfully",
                timer: 3000,
            });

            dispatch(fetchPdfSettings());

            return response.data;

        } catch (error) {
            // Enhanced error handling
            const errorMessage = error.response?.data?.message || "Please try again later.";

            Swal.fire({
                icon: "error",
                title: "Failed",
                text: errorMessage,
                timer: 3000,
            });

            return rejectWithValue(
                error.response?.data || {
                    message: errorMessage,
                    status: error.response?.status
                }
            );
        }
    }
);

export const updateUserPreferences = createAsyncThunk(
    "updateUserPreferences",
    async (datas, { rejectWithValue }) => {
        const token = getToken();

        if (!token) {
            return rejectWithValue({
                message: "No token found, authorization failed.",
            });
        }

        try {
            const response = await axios.post(
                `${Apiurl}user/update-preferences`,
                datas,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            // Also update localStorage so the app doesn't have to wait for reload
            const userDataStr = localStorage.getItem('userData');
            let userData = {};
            if (userDataStr) {
                try {
                    userData = JSON.parse(userDataStr);
                } catch (e) {
                    console.error('Error parsing existing userData:', e);
                }
            }

            if (datas.show_smart_suggestions !== undefined) {
                userData.show_smart_suggestions = datas.show_smart_suggestions;
            }
            if (datas.show_stock_warning !== undefined) {
                userData.show_stock_warning = datas.show_stock_warning;
            }
            if (datas.show_low_stock_warning !== undefined) {
                userData.show_low_stock_warning = datas.show_low_stock_warning;
            }
            if (datas.currency !== undefined) {
                userData.currency = datas.currency;
            }
            if (datas.currency_symbol !== undefined) {
                userData.currency_symbol = datas.currency_symbol;
            }
            localStorage.setItem('userData', JSON.stringify(userData));

            return { user: response.data?.data || datas, message: "Preferences updated successfully." };
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Failed to update preferences." }
            );
        }
    }
);

const userDataStr = typeof window !== 'undefined' ? localStorage.getItem('userData') : null;
let initialShowSmartSuggestions = true;
let initialShowStockWarning = true;
let initialShowLowStockWarning = true;
let initialCurrency = 'INR';
let initialCurrencySymbol = '₹';
if (userDataStr) {
    try {
        const userData = JSON.parse(userDataStr);
        if (userData.show_smart_suggestions !== undefined) {
            initialShowSmartSuggestions = userData.show_smart_suggestions === true || userData.show_smart_suggestions === 1 || userData.show_smart_suggestions === "1";
        }
        if (userData.show_stock_warning !== undefined) {
            initialShowStockWarning = userData.show_stock_warning === true || userData.show_stock_warning === 1 || userData.show_stock_warning === "1";
        }
        if (userData.show_low_stock_warning !== undefined) {
            initialShowLowStockWarning = userData.show_low_stock_warning === true || userData.show_low_stock_warning === 1 || userData.show_low_stock_warning === "1";
        }
        if (userData.currency) {
            initialCurrency = userData.currency;
        }
        if (userData.currency_symbol) {
            initialCurrencySymbol = userData.currency_symbol;
        }
    } catch (e) {
        console.error("Error parsing userData", e);
    }
}

const initialState = {
    coverImages: [],
    summaryImages: [],
    themeImages: [],
    lastImages: [],
    techImages: [],
    communicationImages: [],
    pdfSettings: {},
    showSmartSuggestions: initialShowSmartSuggestions,
    showStockWarning: initialShowStockWarning,
    showLowStockWarning: initialShowLowStockWarning,
    currency: initialCurrency,
    currency_symbol: initialCurrencySymbol,
    loading: false,
    addStatus: "idle",
    getStatus: "idle",
    deleteStatus: "idle",
    updateStatus: "idle",
    error: null,
};

const imageSlice = createSlice({
    name: "images",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCoverImages.pending, (state, action) => {
                state.loading = true;
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchCoverImages.fulfilled, (state, action) => {
                state.coverImages = action.payload.data;
                state.loading = false;
                state.getStatus = "succeeded";
            })
            .addCase(fetchCoverImages.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
                state.getStatus = "failed";
            });

        builder
            .addCase(fetchSummaryImages.pending, (state, action) => {
                state.loading = true;
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchSummaryImages.fulfilled, (state, action) => {
                state.summaryImages = action.payload.data;
                state.loading = false;
                state.getStatus = "succeeded";
            })
            .addCase(fetchSummaryImages.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
                state.getStatus = "failed";
            });

        builder
            .addCase(fetchThemeImages.pending, (state, action) => {
                state.loading = true;
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchThemeImages.fulfilled, (state, action) => {
                state.themeImages = action.payload.data;
                state.loading = false;
                state.getStatus = "succeeded";
            })
            .addCase(fetchThemeImages.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
                state.getStatus = "failed";
            });

        builder
            .addCase(fetchLastImages.pending, (state, action) => {
                state.loading = true;
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchLastImages.fulfilled, (state, action) => {
                state.lastImages = action.payload.data;
                state.loading = false;
                state.getStatus = "succeeded";
            })
            .addCase(fetchLastImages.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
                state.getStatus = "pending";
            });
        builder
            .addCase(fetchTechImages.pending, (state, action) => {
                state.loading = true;
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchTechImages.fulfilled, (state, action) => {
                state.techImages = action.payload.data;
                state.loading = false;
                state.getStatus = "succeeded";
            })
            .addCase(fetchTechImages.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
                state.getStatus = "pending";
            });
        builder
            .addCase(fetchCommunicationImages.pending, (state, action) => {
                state.loading = true;
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchCommunicationImages.fulfilled, (state, action) => {
                state.communicationImages = action.payload.data;
                state.loading = false;
                state.getStatus = "succeeded";
            })
            .addCase(fetchCommunicationImages.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
                state.getStatus = "pending";
            });

        // Consolidated: fetch all image categories in one call
        builder
            .addCase(fetchAllPdfImages.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchAllPdfImages.fulfilled, (state, action) => {
                state.coverImages = action.payload.coverImages ?? [];
                state.summaryImages = action.payload.summaryImages ?? [];
                state.themeImages = action.payload.themeImages ?? [];
                state.lastImages = action.payload.lastImages ?? [];
                state.techImages = action.payload.techImages ?? [];
                state.communicationImages = action.payload.communicationImages ?? [];
                state.loading = false;
                state.getStatus = "succeeded";
            })
            .addCase(fetchAllPdfImages.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
                state.getStatus = "failed";
            });

        builder
            .addCase(addCoverImage.pending, (state, action) => {
                state.addStatus = 'pending';
            })
            .addCase(addCoverImage.fulfilled, (state, action) => {
                state.addStatus = 'succeeded';
            })
            .addCase(addCoverImage.rejected, (state, action) => {
                state.addStatus = 'failed';
                state.error = action.payload;
            })
            .addCase(addSummaryImage.pending, (state, action) => {
                state.addStatus = 'pending';
            })
            .addCase(addSummaryImage.fulfilled, (state, action) => {
                state.addStatus = 'succeeded';
            })
            .addCase(addSummaryImage.rejected, (state, action) => {
                state.addStatus = 'failed';
                state.error = action.payload;
            })
            .addCase(addThemeImage.pending, (state, action) => {
                state.addStatus = 'pending';
            })
            .addCase(addThemeImage.fulfilled, (state, action) => {

                state.addStatus = 'succeeded';
            })
            .addCase(addThemeImage.rejected, (state, action) => {
                state.addStatus = 'failed';
                state.error = action.payload;
            })
            .addCase(addLastImage.pending, (state, action) => {
                state.addStatus = 'pending';
            })
            .addCase(addLastImage.fulfilled, (state, action) => {

                state.addStatus = 'succeeded';
            })
            .addCase(addLastImage.rejected, (state, action) => {
                state.addStatus = 'failed';
                state.error = action.payload;
            })
            .addCase(addTechImage.pending, (state, action) => {
                state.addStatus = 'pending';
            })
            .addCase(addTechImage.fulfilled, (state, action) => {

                state.addStatus = 'succeeded';
            })
            .addCase(addTechImage.rejected, (state, action) => {
                state.addStatus = 'failed';
                state.error = action.payload;
            })
            .addCase(addCommunicationImage.pending, (state, action) => {
                state.addStatus = 'pending';
            })
            .addCase(addCommunicationImage.fulfilled, (state, action) => {

                state.addStatus = 'succeeded';
            })
            .addCase(addCommunicationImage.rejected, (state, action) => {
                state.addStatus = 'failed';
                state.error = action.payload;
            });


        builder
            .addCase(deleteImageThunk.pending, (state, action) => {
                state.deleteStatus = 'pending';
            })
            .addCase(deleteImageThunk.fulfilled, (state, action) => {
                state.deleteStatus = 'succeeded';
            })
            .addCase(deleteImageThunk.rejected, (state, action) => {
                state.deleteStatus = 'failed';
                state.error = action.payload;
            });

        builder
            .addCase(fetchPdfSettings.pending, (state, action) => {
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchPdfSettings.fulfilled, (state, action) => {
                state.pdfSettings = action.payload;
                state.getStatus = "succeeded";
            })
            .addCase(fetchPdfSettings.rejected, (state, action) => {
                state.error = action.payload;
                state.getStatus = "failed";
            })
            .addCase(updatePdfSettings.pending, (state, action) => {
                state.updateStatus = 'pending';
            })
            .addCase(updatePdfSettings.fulfilled, (state, action) => {
                state.updateStatus = 'succeeded';
            })
            .addCase(updatePdfSettings.rejected, (state, action) => {
                state.updateStatus = 'failed';
                state.error = action.payload;
            })
            .addCase(updateUserPreferences.pending, (state) => {
                state.updateStatus = 'pending';
            })
            .addCase(updateUserPreferences.fulfilled, (state, action) => {
                state.updateStatus = 'succeeded';
                if (action.payload.user?.show_smart_suggestions !== undefined) {
                    state.showSmartSuggestions = action.payload.user.show_smart_suggestions;
                }
                if (action.payload.user?.show_stock_warning !== undefined) {
                    state.showStockWarning = action.payload.user.show_stock_warning;
                }
                if (action.payload.user?.show_low_stock_warning !== undefined) {
                    state.showLowStockWarning = action.payload.user.show_low_stock_warning;
                }
                if (action.payload.user?.currency !== undefined) {
                    state.currency = action.payload.user.currency;
                }
                if (action.payload.user?.currency_symbol !== undefined) {
                    state.currency_symbol = action.payload.user.currency_symbol;
                }
            })
            .addCase(updateUserPreferences.rejected, (state, action) => {
                state.updateStatus = 'failed';
                state.error = action.payload;
            });
    },
});

export default imageSlice.reducer;
